<h2 class="property-header">Propriétés de l'action</h2>
<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field>
            <mat-label>Id</mat-label>
            <input matInput type="text" formControlName="id" autocomplete="off" tabindex="1" readonly="true" />
        </mat-form-field>
    </div>
    <div class="form-item form-item-help">
        <mat-form-field>
            <mat-label>Type d'action</mat-label>
            <mat-select formControlName="type" tabindex="2" readonly="true">
                @for (actionType of actionTypes; track actionType.value) {
                <mat-option [value]="actionType.value">{{ actionType.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</form>
<ng-template #dynamicContainer></ng-template>
